import ClientDetail from './CourseDetail';

export default ClientDetail;
